import React from "react";
import nine_slider_1 from '../../assets/nine_slider_1.avif';
import nine_slider_2 from '../../assets/nine_slider_2.avif';
import nine_slider_3 from '../../assets/nine_slider_3.avif';
import nine_slider_4 from '../../assets/nine_slider_4.avif';

const call_cards = [
  {
    titleSmall: 'Начните проект',
    titleBig: 'Давайте создадим рекламу, которая приносит продажи',
    button: 'Обсудить проект',
    img: nine_slider_1,
  },
  {
    titleSmall: 'Получите стратегию',
    titleBig: 'Закажите бесплатный аудит вашего маркетинга',
    button: 'Заказать аудит',
    img: nine_slider_2,
  },
  {
    titleSmall: 'Станьте партнером',
    titleBig: 'Присоединяйтесь к команде профессионалов',
    button: 'Стать партнером',
    img: nine_slider_3,
  },
  {
    titleSmall: 'Консультация',
    titleBig: 'Получите индивидуальную консультацию эксперта',
    button: 'Записаться',
    img: nine_slider_4,
  },
];

const Icon = ({ name, size = 16 }) => {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "shrink-0",
  };

  const paths = {
    arrow: <><path d="M5 12h13" /><path d="m13 6 6 6-6 6" /></>,
  };

  return <svg {...common}>{paths[name]}</svg>;
};

const CallToActionBlock = () => {
  return (
    <section className="bg-bg pb-14 font-[Inter,Manrope,Arial,sans-serif] text-content">
      <div className="mx-auto max-w-[1240px] px-4">
        
        {/* Верхняя сетка: 2 большие карточки */}
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 mb-4">
          {call_cards.slice(0, 2).map((card, index) => (
            <article
              key={index}
              className="group relative flex flex-col justify-between overflow-hidden rounded-2xl border border-line-strong bg-surface p-7 transition-all duration-300 hover:border-accent-hover hover:shadow-[0_10px_30px_rgba(0,0,0,0.06)] min-h-[220px]"
            >
              <div className="relative z-10 max-w-[55%]">
                <div className="text-[10px] font-normal uppercase tracking-[.2em] text-accent mb-2">
                  {card.titleSmall}
                </div>
                <h3 className="text-lg font-medium leading-snug text-content mb-5">
                  {card.titleBig}
                </h3>
                <button className="shine inline-flex items-center gap-2 rounded-lg bg-accent px-4 py-2 text-xs font-medium text-white transition hover:bg-accent-hover">
                  {card.button} <Icon name="arrow" size={13} />
                </button>
              </div>
              
              <img
                src={card.img}
                alt="Декор"
                className="absolute bottom-0 right-0 h-full w-auto object-contain object-bottom transition-transform duration-700 group-hover:scale-105 pointer-events-none"
              />
            </article>
          ))}
        </div>

        {/* Нижняя сетка: 2 карточки + блок подписки */}
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {call_cards.slice(2).map((card, index) => (
            <article
              key={index}
              className="group relative flex flex-col justify-between overflow-hidden rounded-2xl border border-line-strong bg-surface p-7 transition-all duration-300 hover:border-accent-hover hover:shadow-[0_10px_30px_rgba(0,0,0,0.06)] min-h-[220px]"
            >
              <div className="relative z-10 max-w-[55%]">
                <div className="text-[10px] font-normal uppercase tracking-[.2em] text-accent mb-2">
                  {card.titleSmall}
                </div>
                <h3 className="text-lg font-medium leading-snug text-content mb-5">
                  {card.titleBig}
                </h3>
                <button className="shine inline-flex items-center gap-2 rounded-lg bg-accent px-4 py-2 text-xs font-medium text-white transition hover:bg-accent-hover">
                  {card.button} <Icon name="arrow" size={13} />
                </button>
              </div>
              
              <img
                src={card.img}
                alt="Декор"
                className="absolute bottom-0 right-0 h-full w-auto object-contain object-bottom transition-transform duration-700 group-hover:scale-105 pointer-events-none"
              />
            </article>
          ))}

          {/* Карточка подписки */}
          <article className="flex flex-col justify-between overflow-hidden rounded-2xl border border-line-strong bg-surface p-7 transition-all duration-300 hover:border-accent-hover hover:shadow-[0_10px_30px_rgba(0,0,0,0.06)]">
            <div>
              <div className="text-[10px] font-normal uppercase tracking-[.2em] text-accent mb-2">
                Рассылка
              </div>
              <h3 className="text-sm font-medium leading-relaxed text-content mb-4">
                Получайте эксклюзивные предложения и маркетинговые инсайты
              </h3>
            </div>

            <div className="space-y-3">
              <input
                type="email"
                placeholder="Ваш email"
                className="w-full rounded-lg border border-line-strong bg-bg px-4 py-2.5 text-xs text-content outline-none transition focus:border-accent-hover focus:bg-surface"
              />
              <button className="w-full rounded-lg bg-[#17191d] py-2.5 text-xs font-medium text-white transition hover:bg-accent-hover">
                Подписаться
              </button>
            </div>
          </article>
        </div>

      </div>
    </section>
  );
};

export default CallToActionBlock;